// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
// Components, Layouts, Pages
import { BaseToolbar } from '~/components/common';
import PageShell from '~/pages/common/pageShell/PageShell';
// Others
// Styles, images, icons
import styles from './Tags.module.scss';

const cx = classNames.bind(styles);

const Tags = () => {
  //#region Destructuring Props
  const { t } = useTranslation(['admin/tags']);
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <PageShell title={t('tags_title')}>
    <Box component={'div'} id='tagsPage' className={cx('container')}>
      <BaseToolbar />

      <Box component={'div'} className={cx('body')}></Box>
    </Box>
    </PageShell>
  );
};

export default Tags;
